export class PharmacyStoreModel {
    public PharmacyId: string;
    public NCPDPID: string;
    public UpdatedBy: string;
    public NCPDPIDs: string;
}

export class PharmacyStoreResultModel {
    public Errors: Array<ErrorListItem>;
    public ResponseData: string;
    public ResponseMessage: string;
    public ResponseStatus: boolean;
}
  
export class ErrorListItem {
    public ErrorCode: number;
    public ErrorMessage: string;
}